import {createSelector} from "@reduxjs/toolkit";

import selectAllChapterExerciseIds from "../chapters/selectAllChapterExerciseIds";
import selectChapter from "../chapters/selectChapter";
import type {ExerciseOutcomes} from "./ExerciseOutcomes";
import type FetchStatus from "../FetchStatus";
import {keyProvider} from "../keyProvider";
import selectChapterOutcomesFetchStatus from "./selectChapterOutcomesFetchStatus";
import type {RootState} from "../store";

const selectAllChapterOutcomes = createSelector(
	(state: RootState) => state.outcomes.byKey,
	selectChapterOutcomesFetchStatus,
	selectChapter,
	selectAllChapterExerciseIds,
	(
		outcomes,
		status,
		chapter,
		exerciseIds
	): [ExerciseOutcomes[], FetchStatus] => {
		if (!chapter) {
			return [[], "none"];
		}

		return [
			exerciseIds.flatMap(
				(id) => outcomes[keyProvider.chapterExercise(chapter.id, id)] ?? []
			),
			status,
		];
	}
);

export default selectAllChapterOutcomes;
